'use client';

export interface FeaturedEventItem {
  id: string;
  title: string;
  category: 'CONFERENCE' | 'HACKATHON' | 'WORKSHOP' | 'MEETUP' | 'PRODUCT LAUNCH' | 'SUMMIT';
  date: string;
  location: string;
  cover_image: string;
  status: 'draft' | 'published';
  featured: boolean;
  order: number;
  slug?: string;
}

export interface HeroAdminSettings {
  ticketBadgeMode: 'auto' | 'custom';
  customTicketCount: number;
}

export const DEFAULT_HERO_FEATURED_EVENTS: FeaturedEventItem[] = [
  {
    id: 'hero-slot-1',
    category: 'CONFERENCE',
    title: 'Founders Summit',
    date: 'MAR 14',
    location: 'San Francisco',
    cover_image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=600&q=75',
    status: 'published',
    featured: true,
    order: 1,
    slug: 'esummit-es9b8pyi',
  },
  {
    id: 'hero-slot-2',
    category: 'HACKATHON',
    title: 'Build Weekend',
    date: 'APR 02',
    location: 'Austin, TX',
    cover_image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=600&q=75',
    status: 'published',
    featured: true,
    order: 2,
    slug: 'test-1h8ckg7o',
  },
  {
    id: 'hero-slot-3',
    category: 'PRODUCT LAUNCH',
    title: 'DevCon Keynote',
    date: 'JUN 21',
    location: 'New York',
    cover_image: 'https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=600&q=75',
    status: 'published',
    featured: true,
    order: 3,
    slug: 'kyc-cwhzkycm',
  },
  {
    id: 'hero-slot-4',
    category: 'WORKSHOP',
    title: 'AI Engineering Lab',
    date: 'MAY 09',
    location: 'Brooklyn, NY',
    cover_image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=600&q=75',
    status: 'published',
    featured: true,
    order: 4,
    slug: 'hackig-88x9xpue',
  },
  {
    id: 'hero-slot-5',
    category: 'MEETUP',
    title: 'Startup Networking',
    date: 'OCT 25',
    location: 'Chicago',
    cover_image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?auto=format&fit=crop&w=600&q=75',
    status: 'published',
    featured: true,
    order: 5,
    slug: 'test-2-xjdde2er',
  },
  {
    id: 'hero-slot-6',
    category: 'CONFERENCE',
    title: 'Cloud & Infra Summit',
    date: 'JUL 11',
    location: 'Seattle',
    cover_image: 'https://images.unsplash.com/photo-1591115765373-5207764f72e7?auto=format&fit=crop&w=600&q=75',
    status: 'published',
    featured: true,
    order: 6,
    slug: 'arena-yqhafrin',
  },
];

const STORAGE_KEY = 'eh_featured_hero_events_v2';
const SETTINGS_KEY = 'eh_hero_admin_settings_v1';

export function getStoredFeaturedEvents(): FeaturedEventItem[] {
  if (typeof window === 'undefined') return DEFAULT_HERO_FEATURED_EVENTS;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT_HERO_FEATURED_EVENTS;
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed) && parsed.length > 0) {
      return parsed;
    }
  } catch (err) {
    console.error('Error reading featured events from storage:', err);
  }
  return DEFAULT_HERO_FEATURED_EVENTS;
}

export function saveStoredFeaturedEvents(events: FeaturedEventItem[]): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
    window.dispatchEvent(new Event('eh_hero_events_updated'));
  } catch (err) {
    console.error('Error saving featured events to storage:', err);
  }
}

export function getStoredHeroSettings(): HeroAdminSettings {
  const defaultSettings: HeroAdminSettings = {
    ticketBadgeMode: 'auto',
    customTicketCount: 214,
  };
  if (typeof window === 'undefined') return defaultSettings;
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (raw) return { ...defaultSettings, ...JSON.parse(raw) };
  } catch {}
  return defaultSettings;
}

export function saveStoredHeroSettings(settings: HeroAdminSettings): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
    window.dispatchEvent(new Event('eh_hero_events_updated'));
  } catch (err) {
    console.error('Error saving hero settings:', err);
  }
}
